<template>
  <section>
    <loading-tile v-if="isLoading === true" />
    <section
      v-if="isLoading === false"
      :class="getClass()"
    >
      <article
        v-if="(viewItem !== null && typeof viewItem.slug === 'undefined')"
        data-aos="fade-zoom-in"
        class="flex w-full h-full relative flex-col post-card rounded-md shadow-md hover:shadow-2xl"
      >
        <div
          class="group lazy overlay overflow-hidden transition-all relative flex-initial rounded-md h-full background overlay-black" 
          :data-bg="getFallbackImage()"
          :data-bg-hidpi="getFallbackImage()"
        >
          <div class="px-8 py-4 absolute bottom-0 right-0 left-0 flex-auto overlay-content">
            <h6>
              <p
                class="line-clamp-3 font-bold mt-2 block text-xl text-white group-hover:text-primary"
              >
                <span>{{ $t('DATA_NOT_FOUND_ERROR') }}</span>
              </p>
            </h6>
          </div>
        </div>
      </article>
      <article
        v-else
        data-aos="fade-zoom-in"
        class="flex w-full h-full relative flex-col post-card rounded-md shadow-md hover:shadow-2xl"
      >
        <div class="flex items-center justify-between absolute top-8 right-8 left-8 z-20">
          <rating
            v-if="viewItem.rating"
            :value="viewItem.rating"
          />
        </div>
        <div
          class="group lazy overlay overflow-hidden transition-all relative flex-initial rounded-md h-full background overlay-black" 
          :data-bg="getImageSrc(viewItem, 'desktop')"
          :data-bg-hidpi="getImageSrc(viewItem, 'desktop')"
          itemscope=""
          :itemtype="schemaData.type"
        >
          <meta
            itemprop="name"
            :content="schemaData.name"
          >
          <meta
            v-if="mode === 'publications/'"
            itemprop="isbn"
            :content="schemaData.isbn"
          >
          <meta
            v-if="schemaData.description"
            itemprop="description"
            :content="schemaData.description"
          >
          <meta
            v-if="schemaData.genre"
            itemprop="genre"
            :content="schemaData.genre"
            :itemid="schemaData.genreId"
          >
          <meta
            v-if="schemaData.person"
            itemprop="person"
            itemtype="https://schema.org/Person"
            :content="schemaData.person"
            :itemid="schemaData.personId"
          >
          <meta
            v-if="mode === 'publications/' && schemaData.pageCount !== ''"
            itemprop="numberOfPages"
            :content="schemaData.pageCount"
          >
          <meta
            v-if="schemaData.publishDate"
            itemprop="datePublished"
            :content="schemaData.publishDate"
          >
          <meta
            v-if="schemaData.author"
            itemprop="author"
            itemscope
            itemtype="https://schema.org/Person"
            :content="schemaData.author"
            :itemid="schemaData.authorId"
          >
          <meta
            v-if="mode === 'publications/' && schemaData.publisher"
            itemprop="publisher"
            itemtype="https://schema.org/Organization"
            itemscope=""
            :content="schemaData.publisher"
          >
          <a 
            :href="getHref()"
            :title="(viewItem.title) ? viewItem.title : viewItem.completeName"
            class="absolute block w-full h-full"
          >
            <div
              v-if="viewItem.difficulty"
              class="text--difficulty absolute bottom-auto left-auto right-5 top-5 z-10 inline-block -translate-y-1/2 translate-x-2/4 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 rounded-full p-5 text-xs"
              :class="getDifficultyClass()"
            />
            <div class="px-8 py-4 absolute bottom-0 right-0 left-0 flex-auto overlay-content">
              <p
                v-if="typeof viewItem.title !== 'undefined'"
                class="line-clamp-3  font-bold mt-2 block text-xl text-white group-hover:text-primary"
              >
                {{ viewItem.title }}
              </p>
              <p
                v-else
                class="line-clamp-3  font-bold mt-2 block text-xl text-white group-hover:text-primary"
              >
                {{ viewItem.completeName }}
              </p>
              <p
                v-if="viewItem.subTitle"
                class="text-white font-medium transition-all line-clamp-2 text-sm"
              >
                {{ viewItem.subTitle }}
              </p>
            </div>
          </a>
        </div>
      </article>
    </section>
  </section>
</template>

<script>
import axios from "axios";
import {defineAsyncComponent} from "vue";
const Rating = defineAsyncComponent(() => import("../Slider/Rating" /* webpackChunkName: "rating" */));
const LoadingTile = defineAsyncComponent(() =>
  import("../Content/LoadingTile" /* webpackChunkName: "loading-tile" */)
);

export default {
  name: "ApiCard",
  components: {
    Rating,
    LoadingTile
  },
  props: {
    getCall: {
      type: String,
      required: false,
      default: ''
    },
    item: {
      type: Object,
      required: false,
      default: null
    },
    mode: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    class: {
      type: String,
      required: false,
      default: 'h-72 lg:h-96 xl:h-72'
    }
  },
  data() {
    return {
      viewItem: null,
      schemaData: {
      },
      isLoading: true
    }
  },
  created() {
    this.getItem();
  },
  methods: {
    getItem() {
      if (this.item !== null && typeof this.item !== 'undefined') {
        this.viewItem = this.item;
        this.setSchema();

        setTimeout(() => {
          window.LL.update();
        }, "100");
      } else {
        axios.get(process.env.apiURL + this.getCall + this.slug)
          .then(response =>  {
            this.viewItem = response.data;
            this.setSchema();

            setTimeout(() => {
              window.LL.update();
            }, "100");
          })
          .catch(function (error) {
          })
          .then(function () {
          });
      }
    },
    setSchema() {
      switch(this.mode) {
      case 'publications/':
        this.schemaData = {
          name: this.viewItem.completeName,
          type: 'https://schema.org/Book',
          isbn: this.viewItem.isbnLong,
          publishDate: this.viewItem.publishDate,
          pageCount: this.viewItem.pageCount
        };
        this.isLoading = false; 
        break;
      case 'stories/':
        this.schemaData = {
          name: this.viewItem.completeName,
          type: 'https://schema.org/CreativeWork',
          author: this.viewItem.author.name,
          authorId: 'https://storysh.de/community/' + this.viewItem.author.slug,
          publishDate: this.viewItem.publishDate,
        };
        this.isLoading = false;
        break;
      case 'tauschboerse/':
        this.schemaData = {
          name: this.viewItem.title,
          type: 'https://schema.org/TradeAction',
          person: this.viewItem.user.name,
          personId: 'https://storysh.de/community/' + this.viewItem.user.slug,
          description: this.truncate(this.viewItem.description, 144, '...</p>')
        };
        this.isLoading = false;
        break;
      default:
        this.isLoading = false;
        break;
      }
    },
    getClass() {
      return this.class;
    },
    getHref() {
      return (this.mode.substring(0, 1) === '/') ? this.mode + this.viewItem.slug : '/' + this.mode + this.viewItem.slug;
    },
    getTeaser(teaser) {
      return this.truncate(teaser, 144, '...</p>');
    },
    truncate: function (text, length, suffix) {
      if (typeof text === 'undefined') {
        return '';
      }
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    getFallbackImage: function () {
      return 'https://api.storysh.de/_uploads/images/media/fallback/thumbnails/fallback_01_list_desktop.webp'
    },
    getDifficultyClass() {
      if (this.viewItem.difficulty === 1) {
        return 'green'
      }
      if (this.viewItem.difficulty === 2) {
        return 'yellow'
      }
      if (this.viewItem.difficulty === 3) {
        return 'red'
      }
    },
    getImageSrc(item, viewport) {
      if (typeof item.images === "undefined") {
        if (typeof item.image === 'string') {
          if (item.image.includes('fallback')) {
            return 'https://api.storysh.de/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
          }

          return item.image;
        }

        item.images = [item.image];
      }

      if (item.images.length === 0) {
        if (typeof item.image === 'undefined' || item.image.includes('fallback')) {
          return 'https://api.storysh.de/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
        }

        return item.image;
      }

      let imageCount = item.images.length,
        count = 0,
        hasMain = false;

      if (imageCount === 1) {
        if (item.images[0].media.thumbnails.length === 0) {
          if (item.images[0].media.img.includes('fallback')) {
            return 'https://api.storysh.de/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
          }

          return item.images[0].media.img;
        }

        if (item.images[0].media.thumbnails[viewport]['list'].img.includes('fallback')) {
          return process.env.apiURL + '/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
        }

        return item.images[0].media.thumbnails[viewport]['list'].img;
      }

      for (count; count <= imageCount - 1; count++) {
        if (item.images[count].main === true) {
          hasMain = true;


          if (item.images[count].media.thumbnails.length === 0) {
            if (item.images[count].media.img.includes('fallback')) {
              return process.env.apiURL + '/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
            }

            return item.images[count].media.img;
          }
          if (item.images[count].media.thumbnails[viewport]['list'].img.includes('fallback')) {
            return process.env.apiURL + '/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
          }

          return item.images[count].media.thumbnails[viewport]['list'].img;
        }

        if (count === imageCount - 1 && hasMain === false) {
          if (item.images[0].media.thumbnails.length === 0) {
            if (item.images[0].media.img.includes('fallback')) {
              return process.env.apiURL + '/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
            }

            return item.images[0].media.img;
          }
          if (item.images[0].media.thumbnails[viewport]['list'].img.includes('fallback')) {
            return process.env.apiURL + '/site/img/author/list/preview/authorListPreview-' + Math.floor(Math.random() * (26 - 1 + 1) + 1) + '.webp';
          }

          return item.images[0].media.thumbnails[viewport]['list'].img;
        }
      }
    }
  }
}
</script>
